import { IPersonalNote } from "../models";
import { AuthenticatedFetch, CreateAuthHeader } from "../utils/Helpers";

export interface IPersonalNoteService
{
    GetUserNote(): Promise<IPersonalNote | null>;
    CreateUserNote(note: IPersonalNote): Promise<string>;
    UpdateUserNote(note: IPersonalNote): Promise<string>;
}

export class PersonalNoteServiceProvider implements IPersonalNoteService
{
    private controller = "api/personalnotes";
    //private localStorageKey = "Uhrevind_UserPersonalNote";

    public async GetUserNote(): Promise<IPersonalNote | null> 
    {
        const requestOptions = {
            method: 'GET',
            headers: CreateAuthHeader()
        };
        
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        if (!response.ok) {
            if (response.status === 404) {
                // No note found for user yet, return null
                return null;
            }
            throw new Error("Error fetching personal note");
        }

        return await response.json() as IPersonalNote;
    }

    public async CreateUserNote(note: IPersonalNote): Promise<string>
    {
        const requestOptions = {
            method: 'POST',
            headers: CreateAuthHeader(),
            body: JSON.stringify(note)
        };
    
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        return await response.text();
    }

    public async UpdateUserNote(note: IPersonalNote): Promise<string>
    {
        const requestOptions = {
            method: 'PATCH',
            headers: CreateAuthHeader(),
            body: JSON.stringify(note)
        };
    
        const response = await AuthenticatedFetch(this.controller, requestOptions);
        return await response.text();
    }
}